import React, { Component } from "react";
import { injectGlobal } from "styled-components";
import { MediaQueryProvider } from "react-media-query-hoc";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import { Home } from "./pages";

injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Comfortaa:400,700');
  body {
    padding: 0;
    margin: 0;
  };
  * {
    font-family: 'Comfortaa', cursive;
   font-weight: 400; };
`;

const history = createBrowserHistory();

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <MediaQueryProvider>
          <Home />
        </MediaQueryProvider>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js